import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";
import { UnitInterface } from "Casadesk/Entity/Entities/Unit/UnitInterface";

class UnitUpdateWillMount extends Middleware implements MiddlewareInterface {
  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    this.component.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
    });

    const id: number = parseInt(this.component.props.params && this.component.props.params.id, 10);
    const unit: UnitInterface = this.component.props.units.byId[id];
    
    if (!!unit) {
      return this.component.initializePage(unit);
    } else {
      this.component.props.dispatch({
        type: Constants.GLOBAL_UNIT_FOR_UNIT_DETAILS_PAGE,
        payload: {
          unitId: id,
        },
        onSuccess: (unit: UnitInterface) => {
          return this.component.initializePage(unit);
        },
        onError: this.component.redirectBack
      });
    }
  }
}

export default new UnitUpdateWillMount();
